
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'

import Vue from 'vue'
import mixinComponent from './mixinComponent.js'
Vue.use(DatetimePlugin)

export default {
name: 'VyInputTime',
components: {
},
mixins: [mixinComponent],
props: {
title: {type: String, default: ''}, // 标题
placeholder: {type: String, default: '请选择'}, // 占位提示文字
required: {type: Boolean, default: false}, // 必填
readonly: {type: Boolean, default: false}, // 只读
disabled: {type: Boolean, default: false}, // 禁用
hide: {type: Boolean, default: false}, // 隐藏
},
computed: {
currentValue: {
get () {

let dates = this.dateFormat(this.value, 'yyyy-MM-dd hh:mm')
console.log(`${this.title}: `, dates)
return dates
},
set (newValue) {
this.$emit('input', newValue)
},
},
},
methods: {
cellClick () {
if(!this.readonly) {
let _this = this
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确认',
format: 'YYYY-MM-DD HH:mm',
onConfirm (val) {

_this.currentValue = val
_this.$emit('input', val)
},
})
}
},
},
}



// WEBPACK FOOTER //
// ./src/components/basic/VyInputDateTime.vue